// extracted by mini-css-extract-plugin
module.exports = {"container":"dj","list":"ej"};